/* mm-punkte.js — "Kennst du das?" — die vier Saetze, die wir am haeufigsten hoeren.
 *
 * 04.09.2026, Mert: "mehr sections infos zum produkt, beruehrungspunkte anfassen,
 * problem loesen, kreative moderne sections, ideen: scroll sections einbauen bei
 * produkt seite ... step sections, booksmark 21st.dev"
 *
 * BAUSTEIN: "Timeline" von @manuarora700 (aceternity), aus Merts eigener
 * 21st-Sammlung "Steps": sticky Titel links, senkrechte Linie mit Maske, und ein
 * Strahl, der beim Scrollen mitwaechst. Genau die gewuenschte Scroll-Sektion.
 *
 * KEINE zweite Schritt-Sektion: "Schritt fuer Schritt" gibt es schon
 * (mm-schritte.js). Diese hier ist der fehlende Teil - die Beruehrungspunkte:
 * erst das Problem beim Namen nennen, dann sagen, wo Magic Milk ansetzt.
 *
 * 1:1 UEBERNOMMEN: sticky Titel, 40px-Punkt mit 16px-Kern, 2px-Linie mit
 * Farbverlauf und weicher Maske oben/unten, mitwachsender Strahl am
 * Scroll-Fortschritt (Fenster "Anfang bei 10 % - Ende bei 50 %"), Titel gross
 * und in gedaempfter Farbe, Inhalt rechts daneben.
 *
 * UMGESTELLT: Farben auf die Marke (Strahl in Rot statt Lila/Blau, kein pinker
 * Text), Theme-Schriften, aus React/framer-motion wurde reines JS. Die Abstaende
 * sind kleiner als im Original (40/80px statt 160px) - Merts Regeln "Seite
 * minimal lang" und "PC nie viel groesser als Handy".
 *
 * 🔴 MERTS REGEL "keine langen leeren Felder": JEDER Text steht sofort da.
 * Der Strahl ist reine Zierde - faellt das Skript aus, aendert sich am Inhalt
 * nichts. Es gibt keine Zeile, die erst beim Scrollen erscheint.
 *
 * Der Scroll-Rechner laeuft nur, solange die Sektion im Bild ist, und haengt an
 * requestAnimationFrame statt am Scroll-Ereignis (Ruhe-Regel, 23.08.2026).
 */
(function () {
  'use strict';

  var ROT = '#E5142A';
  var skriptBasis = document.currentScript && document.currentScript.src;
  var FLAECHEN = ['#FFF0E5', '#EAF3FF', '#FFF7D8', '#E7F4EB'];

  /* Ein eigener Ton je Station (Mert, 05.09.2026: „verschiedene farben bei
     steps"). Alle vier kommen aus der Markenwelt - Rot und Rose sind
     Markenfarben, Gold ist die Akzentfarbe aus den Grundregeln; Gruen bleibt
     draussen, das ist Bedienfarbe. Der Bogen laeuft warm von Rot ueber Koralle
     zu Gold und klingt in Rose aus.
     Die Werte stehen bei TOENE weiter unten und sind auf den HELLEN Grund
     gerechnet - seit dem 05.09.2026 ist die Sektion weiss. Gefaerbt werden nur
     Zeichen, Ring und Schein - die Ueberschriften bleiben Creme, farbiger
     Flaechentext waere gegen die Regel. */
  /* 05.09.2026, Mert: „Mach die Section weiss, also hell. Das heisst, die
     Texte dann schwarz." Damit dreht sich die ganze Farbwelt der Sektion um -
     und die vier Stationstoene muessen mit, sonst stehen sie auf Weiss im
     Nichts. Nachgerechnet auf #FFFFFF statt geschaetzt:
       alte Toene:  Rot 4,70 - Koralle 2,68 - Gold 1,80 - Rose 2,15
       drei davon liegen UNTER der 3:1-Schwelle, Gold war praktisch unsichtbar.
     Die dunkleren Fassungen behalten den warmen Bogen Rot → Koralle → Gold →
     Rose und liegen alle darueber. */
  /* 06.09.2026, Mert: „die symbole deren hintergrund farblicher machen" und
     „nicht weiss von den symbolen", davor „du hast zu viel mit Pink und Rot
     gearbeitet. Farblicher."
     Vorher waren drei der vier Toene aus derselben Ecke (Rot, Koralle, Rose) -
     auf dem Bildschirm sah die Bahn dadurch einfarbig rot aus. Jetzt vier
     Toene aus vier Himmelsrichtungen des Farbkreises, kleinster Abstand
     26 Grad. Gruen war hier bisher ausgeschlossen ("Bedienfarbe"); Mert hebt
     das mit derselben Ansage auf, mit der er WhatsApp gruen haben wollte.
     Alle vier auf WEISS gerechnet, nicht geschaetzt: */
  var TOENE = [
    '199,82,42',    /* Essen    - Terrakotta, 4,50:1 auf Weiss */
    '46,111,176',   /* Training - Blau,       5,23:1 */
    '168,116,0',    /* Morgens  - Gold,       4,07:1 */
    '46,125,91'     /* Probiert - Gruen,      5,00:1 */
  ];

  /* Die Grundfarben der Sektion an einer Stelle, damit ein Umschwenken nicht
     wieder ueber zwanzig verstreute Werte geht. */
  var GRUND      = '#FFFFFF';                 /* Flaeche */
  var TEXT       = '#151013';                 /* Ueberschriften, 18,8:1 */
  var TEXT_MITTE = 'rgba(21,16,19,.72)';      /* Fliesstext */
  var TEXT_LEISE = 'rgba(21,16,19,.52)';      /* Ruhezustand, 3,42:1 */
  var LINIE      = 'rgba(21,16,19,.20)';      /* Raender, Grundschiene */
  var LINIE_ZART = 'rgba(21,16,19,.08)';
  /* Als RGB-Tripel und nicht als Hex: nur so laesst sich derselbe Ton
     gleichzeitig voll (rgb(...)) und durchscheinend (rgba(...,.62)) einsetzen -
     ein Hex-Wert in einer Variablen funktioniert in rgba() nicht. */

  /* Ein Zeichen je Satz (Mert, 05.09.2026): "mach als symbole passend zum
     thema, z.b bei essen, essen symbol, bei trainiere, hantel oder muskel,
     morgens, sonne symbol oder was passenderes".
     Bewusst als Strichzeichnung in einer 24er-Flaeche: bei 18 Pixeln bleibt
     davon noch etwas lesbar, eine gefuellte Form waere dort nur ein Klecks.
     `currentColor` heisst, die Farbe kommt aus dem Zustand des Halts - grau,
     solange er schlaeft, rot sobald er wach ist. */
  /* Ein Zeichen je Satz — 05.09.2026 auf Merts Ansage von Strich auf
     **mattes Comicdesign** umgezeichnet: „die Symbole müssen die Symbole sein,
     die grade dort sind … nur das Design verändern."
     Also dieselben vier Motive: Gabel und Messer, Hantel, Sonne über dem
     Horizont, Kreispfeil. Keine Alternativen.

     Was sich ändert: statt duenner Konturen jetzt gefuellte, runde Koerper —
     zwei Ebenen uebereinander. Unten eine matte Flaeche im Stationston bei
     22 Prozent (`mmZfl`), darauf die Form in Vollton (`mmZvoll`). Das ergibt
     den weichen Comic-Eindruck, ohne dass die Farbe grell wird — Merts Regel
     „Farben nie knallig" bleibt gewahrt, weil die Saettigung aus der matten
     Unterlage kommt und nicht aus einem harten Rand.
     Alle Koordinaten in einer 24er Flaeche, alle Ecken gerundet. */
  var ZEICHEN = {
    /* Gabel und Messer — Griffe als Kapseln, Zinken als drei kurze Balken,
       Klinge als weiche Sichel. */
    essen:
      '<g class="mmZfl">' +
        '<rect x="4.6" y="2.4" width="5.6" height="7.4" rx="2.6"/>' +
        '<rect x="14.4" y="2.4" width="5" height="9.4" rx="2.5"/>' +
      '</g>' +
      '<g class="mmZvoll">' +
        '<rect x="5.1" y="2.9" width="1.5" height="5.2" rx="0.75"/>' +
        '<rect x="6.9" y="2.9" width="1.5" height="5.2" rx="0.75"/>' +
        '<rect x="8.7" y="2.9" width="1.5" height="5.2" rx="0.75"/>' +
        '<rect x="6.4" y="7.4" width="2.4" height="13.8" rx="1.2"/>' +
        '<path d="M18.7 3.2c-1.9 1.5-2.8 3.6-2.8 5.6 0 1.5.8 2.5 2 2.8V3.2z"/>' +
        '<rect x="16.7" y="10.6" width="2.4" height="10.6" rx="1.2"/>' +
      '</g>',

    /* Hantel — zwei dicke Scheiben, dazwischen die Stange. */
    hantel:
      '<g class="mmZfl">' +
        '<rect x="0.8" y="5.6" width="6.8" height="12.8" rx="3"/>' +
        '<rect x="16.4" y="5.6" width="6.8" height="12.8" rx="3"/>' +
      '</g>' +
      '<g class="mmZvoll">' +
        '<rect x="2.2" y="7" width="4" height="10" rx="2"/>' +
        '<rect x="17.8" y="7" width="4" height="10" rx="2"/>' +
        '<rect x="6" y="10" width="12" height="4" rx="2"/>' +
      '</g>',

    /* Sonne ueber dem Horizont — Halbkreis, kurze Strahlen, Grundlinie. */
    morgens:
      '<g class="mmZfl">' +
        '<path d="M4 16.2a8 8 0 0 1 16 0z"/>' +
      '</g>' +
      '<g class="mmZvoll">' +
        '<path d="M7 16.2a5 5 0 0 1 10 0z"/>' +
        /* Fuenf Strahlen im Faecher: senkrecht, zweimal schraeg, zweimal flach
           - alle gleich lang und um die Sonnenmitte (12/16,2) gedreht, damit
             keiner wie ein loser Strich daneben steht. */
        '<rect x="11" y="1.4" width="2" height="3.6" rx="1"/>' +
        '<rect x="11" y="1.4" width="2" height="3.6" rx="1" transform="rotate(-38 12 16.2)"/>' +
        '<rect x="11" y="1.4" width="2" height="3.6" rx="1" transform="rotate(38 12 16.2)"/>' +
        '<rect x="11" y="1.4" width="2" height="3.6" rx="1" transform="rotate(-72 12 16.2)"/>' +
        '<rect x="11" y="1.4" width="2" height="3.6" rx="1" transform="rotate(72 12 16.2)"/>' +
        '<rect x="2.6" y="17.8" width="18.8" height="2" rx="1"/>' +
      '</g>',

    /* Kreispfeil — dicker Bogen, satte Spitze. Steht fuer „schon einmal
       herum, jetzt wieder von vorn". */
    wieder:
      /* Als dicker runder Bogen statt als Flaechenring: eine 5,4 breite Linie
         mit runden Enden liest sich auf 23 Pixeln als Comic-Koerper, waehrend
         ein aus zwei Kreisen gebauter Ring dort zu einem duennen „C" zerfaellt.
         Die Spitze sitzt am offenen Ende oben und zeigt in die Laufrichtung. */
      '<g class="mmZfl">' +
        '<path d="M20.4 12a8.4 8.4 0 1 1-8.4-8.4" ' +
          'fill="none" stroke="currentColor" stroke-width="8.6" ' +
          'stroke-linecap="round"/>' +
      '</g>' +
      '<g class="mmZvoll">' +
        '<path d="M20.4 12a8.4 8.4 0 1 1-8.4-8.4" ' +
          'fill="none" stroke="currentColor" stroke-width="4.6" ' +
          'stroke-linecap="round"/>' +
        '<path d="M10.6 0.6l5.4 3.1-5.4 3.1z"/>' +
      '</g>'
  };

  var STATIONEN = [
    {
      titel: 'Ich esse\ndoch genug',
      zeichen: 'essen',
      text: 'Der Satz, den wir am häufigsten hören. Meistens stimmt er sogar — nur reicht ' +
            '„genug" nicht, wenn der Körper mehr verbraucht, als auf dem Teller liegt. ' +
            'Das Problem ist selten das falsche Essen, sondern die fehlende Lust auf die Menge.',
      punkte: ['Es liegt am Appetit', 'Kaum eigene Kalorien']
    },
    {
      titel: 'Ich trainiere\nund nichts passiert',
      zeichen: 'hantel',
      text: 'Training erhöht den Verbrauch. Wer danach keinen Hunger hat, kommt gar nicht ' +
            'erst auf die Menge, die der Plan verlangt. Genau da setzt ein Appetitanreger an — ' +
            'er ersetzt kein Training und keine Mahlzeit.',
      punkte: ['Ein Stick vor der Mahlzeit', '30 Beutel, 5 g']
    },
    {
      titel: 'Morgens\nkriege ich\nnichts runter',
      zeichen: 'morgens',
      text: 'Der häufigste Berührungspunkt. Magic Milk wird vor einer Mahlzeit getrunken, ' +
            'nicht statt einer. Zehn pflanzliche Zutaten und Milchpulver, kein Koffein, ' +
            'kein Zuckerschub.',
      punkte: ['Vor dem Essen', '10 Zutaten, kein Koffein']
    },
    {
      titel: 'Ich habe\nschon alles\nprobiert',
      zeichen: 'wieder',
      text: 'Dann sagen wir es offen: Eine Garantie gibt es nicht. Wir empfehlen mindestens ' +
            'drei Monate, weil sich in kürzerer Zeit selten etwas zeigt. Den Rest machst du ' +
            'am Tisch — wir liefern nur den Anstoß.',
      punkte: ['Keine Garantie', 'Ab 3 Monaten']
    }
  ];

  var css = [
    '#mmPu{background:' + GRUND + ';color:' + TEXT + ';padding:clamp(30px,5vw,52px) 0 clamp(20px,4vw,40px);',
      /* `clip` und nicht `hidden`: beides schneidet gleich ab, aber `hidden`
         macht die Sektion zu einem Scroll-Behaelter und toetet damit jedes
         `position:sticky` im Inneren - genau daran waere das Einfrieren
         gescheitert. Dieselbe Lehre steht in mm-schritte.js. */
      'position:relative;overflow:clip}',
    '#mmPu *{box-sizing:border-box}',

    /* Die Sektion setzte bisher GAR KEINE Schrift und erbte, was das Theme
       gerade vorgab - deshalb wirkte sie neben den anderen Bausteinen fremd.
       Jetzt die Markenschriften: Bricolage Grotesque traegt die Titel,
       Manrope den Lesetext. Beide mit echtem Fallback, damit nichts springt,
       falls eine Datei fehlt. */
    '#mmPu .mmPuTitel,#mmPu .mmPuTitelKlein,#mmPu h2{',
      'font-family:"Bricolage Grotesque","Barlow Condensed",',
      'system-ui,-apple-system,sans-serif;font-optical-sizing:auto}',
    '#mmPu .mmPuText,#mmPu .mmPuUnter,#mmPu .mmPuAuge,#mmPu .mmPuListe{',
      'font-family:Manrope,system-ui,-apple-system,sans-serif}',
    /* Ziffern in den Merksaetzen laufen sonst unterschiedlich breit und der
       Block zappelt beim Aufdecken. */
    '#mmPu .mmPuListe li{font-variant-numeric:tabular-nums}',
    '#mmPu .mmPuInnen{max-width:1000px;margin:0 auto;padding:0 clamp(14px,3vw,22px)}',
    '#mmPu .mmPuKopf{max-width:640px;margin:0 0 clamp(18px,3vw,30px)}',
    '#mmPu .mmPuAuge{display:inline-flex;align-items:center;gap:8px;margin:0 0 10px;',
      'font-size:.62rem;font-weight:800;letter-spacing:.14em;text-transform:uppercase;',
      'color:rgba(21,16,19,.62)}',
    '#mmPu .mmPuAuge:before{content:"";width:18px;height:2px;background:' + ROT + '}',
    '#mmPu h2{margin:0;font-size:clamp(1.7rem,4.6vw,2.5rem);line-height:1.04;',
      'letter-spacing:-.02em;font-weight:800;color:' + TEXT + '}',
    '#mmPu .mmPuUnter{margin:9px 0 0;font-size:.85rem;line-height:1.6;',
      'color:rgba(21,16,19,.58)}',

    /* Die Bahn - 1:1 der Baustein: Linie links, Punkt, sticky Titel, Inhalt rechts */
    '#mmPu .mmPuBahn{position:relative;padding-bottom:10px}',

    /* --- Einfrieren beim Scrollen (Mert, 05.09.2026) ---------------------
       „man soll festhaengen beim Scrollen, also dieses Einfriereneffekt."
       Derselbe Bau wie auf der AUREON-Startseite: der Rahmen ist so hoch wie
       der Block PLUS ein Anlaufweg, der Block darin klebt. Man scrollt also
       den Anlaufweg ab, waehrend der Block still an derselben Stelle im
       Fenster steht - und genau dieser Weg deckt die vier Saetze auf.
       Beide Werte setzt das Skript, weil sie von der Fensterhoehe abhaengen;
       ohne sie bleibt alles im normalen Fluss. */
    '#mmPu .mmPuPin.mmPuFest{height:var(--mmPuPinHoehe)}',
    '#mmPu .mmPuPin.mmPuFest .mmPuKleb{position:sticky;top:var(--mmPuPinOben)}',

    /* Im geklebten Zustand ruecken die Saetze enger zusammen, damit alle vier
       zugleich ins Fenster passen - ein Block, der beim Kleben unten
       herausragt, waere ein abgeschnittener Block. Gemessen: 4 x 210 px sind
       849 px und passen nicht in 802 px Fenster; mit dem engeren Abstand sind
       es rund 640 px. */
    /* Die Auswahl muss die Media-Regel weiter unten schlagen
       (`@media(min-width:820px){#mmPu .mmPuHalt{padding-top:80px}}`) - sie
       steht spaeter in derselben Datei und haette bei gleicher Staerke
       gewonnen. Gemessen war der Block sonst 937 px und passte nicht in ein
       820er Fenster, das Einfrieren waere still ausgefallen. */
    '#mmPu .mmPuPin.mmPuFest .mmPuBahn{padding-bottom:0}',
    '#mmPu .mmPuPin.mmPuFest .mmPuBahn .mmPuHalt{padding-top:10px}',
    '#mmPu .mmPuPin.mmPuFest .mmPuBahn .mmPuHalt:first-child{padding-top:0}',
    '#mmPu .mmPuPin.mmPuFest .mmPuBahn .mmPuTitelKlein{margin-bottom:5px;font-size:1.2rem}',
    '#mmPu .mmPuPin.mmPuFest .mmPuBahn .mmPuText{margin-bottom:6px;line-height:1.45}',
    '#mmPu .mmPuPin.mmPuFest .mmPuBahn .mmPuListe{gap:6px}',
    '#mmPu .mmPuPin.mmPuFest .mmPuBahn .mmPuListe li{padding:5px 10px}',
    '#mmPu .mmPuHalt{display:flex;justify-content:flex-start;padding-top:40px;gap:0}',
    '@media(min-width:820px){#mmPu .mmPuHalt{padding-top:80px;gap:40px}}',
    '#mmPu .mmPuLinks{position:sticky;top:96px;z-index:4;align-self:flex-start;',
      'display:flex;align-items:center;flex:0 0 auto;width:0}',
    '@media(min-width:820px){#mmPu .mmPuLinks{width:100%;max-width:330px}}',
    /* Der Halt bleibt genau 40 Pixel breit - er sitzt mittig auf der Linie,
       jede andere Groesse wuerde ihn danebenschieben. Innen steht jetzt das
       Zeichen statt des fruehereren Punktes. */
    /* 06.09.2026: Der Kreis war weiss mit grauem Rand, das Zeichen grau - auf
       weissem Grund sah die Reihe farblos aus. Jetzt traegt schon der
       Ruhezustand den Ton der Station: Fuellung 10 %, Rand 30 %. Gerechnet,
       damit das Zeichen darauf lesbar bleibt (siehe unten). */
    '#mmPu .mmPuPunkt{position:absolute;left:0;width:44px;height:44px;border-radius:50%;',
      'background:rgba(var(--mmPuTon,199,82,42),.10);',
      'display:flex;align-items:center;justify-content:center;',
      'border:1px solid rgba(var(--mmPuTon,199,82,42),.30);box-sizing:border-box;',
      'transition:border-color .45s ease,box-shadow .45s ease,background-color .45s ease}',
    /* Gefuellt statt gestrichelt: die Zeichen sind jetzt Koerper, keine
       Konturen. Zwei Ebenen - matte Unterlage (22 %) und Vollton darauf.
       `fill` wird vererbt, deshalb reicht eine Farbe je Ebene. */
    '#mmPu .mmPuPunkt svg{width:23px;height:23px;display:block;stroke:none;',
      'overflow:visible;transition:opacity .45s ease}',
    /* `color` wird mitgesetzt, weil der Bogen im Kreispfeil ueber
       `stroke="currentColor"` faerbt - `fill` allein erreicht ihn nicht. */
    '#mmPu .mmPuPunkt svg .mmZfl{fill:rgba(var(--mmPuTon,199,82,42),.22);',
      'color:rgba(var(--mmPuTon,199,82,42),.22);',
      'transition:fill .45s ease,color .45s ease}',
    /* 90 % und nicht weniger: bei 78 % faellt Gold auf der eigenen Fuellung
       auf 2,54:1 und liegt damit unter der Grafik-Schwelle von 3:1. */
    '#mmPu .mmPuPunkt svg .mmZvoll{fill:rgba(var(--mmPuTon,199,82,42),.90);',
      'color:rgba(var(--mmPuTon,199,82,42),.90);',
      'transition:fill .45s ease,color .45s ease}',
    /* Erreicht: Fuellung von 10 auf 16 %, Rand und Schein kraeftiger. Das
       frueher fest verdrahtete #FFF4F5 (ein Rosa) ist raus - es passte nur zu
       Rot und liess Blau, Gold und Gruen falsch aussehen. */
    '#mmPu .mmPuHalt.wach .mmPuPunkt{border-color:rgba(var(--mmPuTon,199,82,42),.62);',
      'background:rgba(var(--mmPuTon,199,82,42),.16);',
      'box-shadow:0 0 0 5px rgba(var(--mmPuTon,199,82,42),.13)}',
    '#mmPu .mmPuHalt.wach .mmPuPunkt svg .mmZfl{',
      'fill:rgba(var(--mmPuTon,199,82,42),.28);',
      'color:rgba(var(--mmPuTon,199,82,42),.28)}',
    '#mmPu .mmPuHalt.wach .mmPuPunkt svg .mmZvoll{',
      'fill:rgb(var(--mmPuTon,199,82,42));color:rgb(var(--mmPuTon,199,82,42))}',
    /* nth-of-type und nicht nth-child: in der Bahn steht als erstes Kind die
       Linie (ein span), die Haltepunkte sind divs. Mit nth-child muesste man
       hier um eins versetzt zaehlen - das bricht, sobald jemand ein weiteres
       Element davorsetzt. */
    TOENE.map(function (t, i) {
      return '#mmPu .mmPuBahn > div.mmPuHalt:nth-of-type(' + (i + 1) + '){--mmPuTon:' + t + '}';
    }).join(''),
    '#mmPu .mmPuTitel{display:none;margin:0;padding-left:76px;font-weight:800;',
      'font-size:clamp(1.5rem,3.4vw,2.6rem);line-height:1.02;letter-spacing:-.02em;',
      'color:rgba(21,16,19,.52);white-space:pre-line;transition:color .45s ease}',
    '#mmPu .mmPuHalt.wach .mmPuTitel{color:' + TEXT + '}',

    /* Einblenden beim Scrollen (Mert, 05.09.2026): „wenn man nicht scrollt,
       wenn man ganz oben ist, ist da leer und dann kommt erst, wenn man
       scrollt die Sections."

       Zwei getrennte Zustaende, und das ist der Kern:
         .gesehen  einmal erreicht, bleibt fuer immer - dafuer ist der Halt da
         .wach     nur solange er im Blick ist - dafuer ist die Farbe da
       Wuerde die Sichtbarkeit an `wach` haengen, verschwaende der Text wieder,
       sobald man weiterscrollt. Einmal Gelesenes darf nicht verschwinden.

       Die Regeln haengen an `.mmPuAn`, und die Klasse setzt nur das Skript:
       ohne JavaScript steht alles sofort vollstaendig da, ebenso bei
       „weniger Bewegung". Der Kopf der Sektion (Augenbraue, Ueberschrift,
       Unterzeile) bleibt immer stehen - genau wie auf der AUREON-Startseite,
       wo „VOM ANGEBOT BIS ZUR AUSZAHLUNG" auch bei 0 Prozent zu lesen ist. */
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt{opacity:0;transform:translateY(30px)}',
    /* Die Uebergaenge kommen erst einen Frame spaeter dazu (`mmPuScharf`),
       sonst laeuft beim Laden eine Blende von sichtbar nach unsichtbar und
       alle vier Halte blitzen kurz auf - am 05.09. an der Steps-Sektion
       gemessen und dort mit demselben Kniff behoben. */
    '#mmPu .mmPuBahn.mmPuAn.mmPuScharf .mmPuHalt{',
      'transition:opacity .55s cubic-bezier(.22,.61,.36,1),',
      'transform .55s cubic-bezier(.22,.61,.36,1)}',
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt.gesehen{opacity:1;transform:none}',

    /* „bei ich esse doch genug und dann der Untertext" (Mert, 05.09.2026):
       innerhalb eines Halts kommt erst die Ueberschrift, dann der Absatz, dann
       die beiden Merksaetze. Gestaffelt ueber transition-delay statt ueber
       eigene Klassen - der Rechner muss dafuer nichts zusaetzlich messen.
       Der Punkt an der Linie faehrt mit dem Titel, er gehoert zu ihm. */
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt .mmPuTitelKlein,',
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt .mmPuText,',
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt .mmPuListe{opacity:0;transform:translateY(14px)}',
    '#mmPu .mmPuBahn.mmPuAn.mmPuScharf .mmPuHalt .mmPuTitelKlein,',
    '#mmPu .mmPuBahn.mmPuAn.mmPuScharf .mmPuHalt .mmPuText,',
    '#mmPu .mmPuBahn.mmPuAn.mmPuScharf .mmPuHalt .mmPuListe{',
      'transition:opacity .5s cubic-bezier(.22,.61,.36,1),',
      'transform .5s cubic-bezier(.22,.61,.36,1)}',
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt.gesehen .mmPuTitelKlein{',
      'opacity:1;transform:none;transition-delay:.10s}',
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt.gesehen .mmPuText{',
      'opacity:1;transform:none;transition-delay:.22s}',
    '#mmPu .mmPuBahn.mmPuAn .mmPuHalt.gesehen .mmPuListe{',
      'opacity:1;transform:none;transition-delay:.34s}',
    '@media(min-width:820px){#mmPu .mmPuTitel{display:block}}',
    '#mmPu .mmPuRechts{position:relative;width:100%;padding-left:66px;padding-right:4px}',
    '@media(min-width:820px){#mmPu .mmPuRechts{padding-left:6px}}',
    '#mmPu .mmPuTitelKlein{display:block;margin:0 0 10px;font-weight:800;font-size:1.35rem;',
      'line-height:1.06;letter-spacing:-.02em;color:#151013;white-space:pre-line}',
    '@media(min-width:820px){#mmPu .mmPuTitelKlein{display:none}}',
    '#mmPu .mmPuText{margin:0 0 12px;font-size:.9rem;line-height:1.65;',
      'color:rgba(21,16,19,.70);max-width:52ch}',
    '#mmPu .mmPuListe{margin:0;padding:0;list-style:none;display:flex;flex-wrap:wrap;gap:8px}',
    /* 05.09.2026, Mert: „Diese KI-Slops raus … Macht das viel mehr designter."
       Die Kapsel mit dem grauen Punkt davor war Standardware. Jetzt eine
       Faktenmarke: linke Kante im Stationston, eckiger Zuschnitt statt
       Vollrundung, engere Laufweite. Damit haengt der Merksatz sichtbar am
       Symbol seines Satzes, statt beliebig danebenzustehen. */
    '#mmPu .mmPuListe li{position:relative;display:flex;align-items:center;',
      'font-size:.68rem;font-weight:700;letter-spacing:.02em;',
      'color:rgba(21,16,19,.78);border:1px solid rgba(21,16,19,.13);',
      'border-left:3px solid rgba(var(--mmPuTon,199,82,42),.5);',
      'border-radius:3px 8px 8px 3px;padding:6px 12px 6px 11px;',
      'background:rgba(21,16,19,.028);',
      'transition:border-left-color .45s ease,background-color .45s ease}',
    '#mmPu .mmPuHalt.wach .mmPuListe li{',
      'border-left-color:rgb(var(--mmPuTon,199,82,42));',
      'background:rgba(var(--mmPuTon,199,82,42),.05)}',
    /* Der rote Punkt vor jedem Merksatz ist weg - die farbige Kante links
       macht dieselbe Arbeit, und zwei Farbmarken je Zeile waren eine zu viel. */

    /* Linie und mitlaufender Strahl */
    '#mmPu .mmPuLinie{position:absolute;left:20px;top:0;width:2px;overflow:hidden;',
      'background:linear-gradient(to bottom,transparent,rgba(21,16,19,.20),transparent);',
      '-webkit-mask-image:linear-gradient(to bottom,transparent 0,#000 10%,#000 90%,transparent 100%);',
      'mask-image:linear-gradient(to bottom,transparent 0,#000 10%,#000 90%,transparent 100%)}',
    /* Der Strahl nimmt den Bogen der vier Stationstoene mit: unten Rot, oben
       Rose. `background-size` ist bewusst auf die volle Bahnhoehe gesetzt und
       nicht auf die des Strahls - sonst wuerde der Verlauf beim Wachsen
       mitwandern statt aufgedeckt zu werden, und jeder Halt haette denselben
       Farbausschnitt. Die Hoehe setzt das Skript, nicht das CSS. */
    '#mmPu .mmPuStrahl{position:absolute;left:0;top:0;width:2px;height:0;border-radius:2px;',
      /* 06.09.2026: Bewusst vier Baender mit kurzen Uebergaengen statt eines
         weichen Verlaufs. Terrakotta nach Blau weich zu blenden fuehrt durch
         Graubraun - vier Ecken des Farbkreises ergeben ineinandergerechnet
         immer Matsch. So traegt jeder Abschnitt sauber die Farbe seiner
         Station. */
      'background:linear-gradient(to bottom,',
        'rgb(' + TOENE[0] + ') 0 21%,rgb(' + TOENE[1] + ') 29% 46%,',
        'rgb(' + TOENE[2] + ') 54% 71%,rgb(' + TOENE[3] + ') 79% 100%);',
      'background-size:100% var(--mmPuBahnhoehe,100%);background-repeat:no-repeat;opacity:0}',

    /* 17.09.2026: Jede Station bekommt eine eigene helle Flaeche.
       Badge wie Merts Referenz: weicher Farbkern, weisser Doppelring,
       kraeftiges mattes Motiv. Die vier SVG-Motive bleiben unveraendert. */
    '#mmPu .mmPuStation{position:relative;margin:0 0 20px;border-radius:28px;',
      'background:var(--mmPuFlaeche);isolation:isolate}',
    '#mmPu .mmPuStand{width:100%;padding:26px 20px 30px;border-radius:28px;',
      'background:var(--mmPuFlaeche)}',
    '#mmPu .mmPuBahn .mmPuHalt{padding:0;gap:0;min-height:250px}',
    '#mmPu .mmPuBahn .mmPuLinks{position:relative;top:auto;align-self:stretch}',
    '#mmPu .mmPuPunkt{width:60px;height:60px;left:0;top:0;',
      'background:var(--mmPuFlaeche);border:3px solid #fff;',
      'box-shadow:0 0 0 4px rgba(255,255,255,.68),inset 0 0 0 2px rgba(var(--mmPuTon),.08)}',
    '#mmPu .mmPuPunkt:after{content:"";position:absolute;inset:3px;',
      'border:1px solid rgba(255,255,255,.9);border-radius:inherit;pointer-events:none}',
    '#mmPu .mmPuPunkt svg{width:29px;height:29px}',
    '#mmPu .mmPuHalt .mmPuPunkt svg .mmZvoll{fill:rgb(var(--mmPuTon));color:rgb(var(--mmPuTon))}',
    '#mmPu .mmPuHalt .mmPuPunkt svg .mmZfl{fill:rgba(var(--mmPuTon),.28);color:rgba(var(--mmPuTon),.28)}',
    '#mmPu .mmPuHalt.wach .mmPuPunkt{background:var(--mmPuFlaeche);',
      'border-color:rgb(var(--mmPuTon));box-shadow:0 0 0 4px #fff}',
    '#mmPu .mmPuRechts{padding:0 0 0 80px}',
    '#mmPu .mmPuLinks:after{content:"";position:absolute;left:29px;top:76px;bottom:0;',
      'width:2px;border-radius:2px;background:rgba(var(--mmPuTon),.22)}',
    '#mmPu .mmPuBahn>.mmPuLinie{display:none}',
    '#mmPu .mmPuListe li{background:rgba(255,255,255,.6)}',
    '#mmPu .mmPuHalt.wach .mmPuListe li{background:rgba(255,255,255,.8)}',
    '@media(min-width:820px){#mmPu .mmPuStand{padding:30px}',
      '#mmPu .mmPuBahn .mmPuHalt{gap:26px;min-height:240px}',
      '#mmPu .mmPuRechts{padding:0}#mmPu .mmPuTitel{padding-left:80px;font-size:2rem}}',
    '@media(max-width:379px){#mmPu .mmPuStand{padding:24px 16px}',
      '#mmPu .mmPuPunkt{width:50px;height:50px}',
      '#mmPu .mmPuLinks:after{left:24px;top:66px}',
      '#mmPu .mmPuRechts{padding-left:66px}}',
    '#mmPu.mmPuPause .mmPuBahn *{transition:none!important}',
    '@media(prefers-reduced-motion:reduce){',
      '#mmPu .mmPuStrahl{display:none}',
      '#mmPu .mmPuTitel,#mmPu .mmPuPunkt,#mmPu .mmPuPunkt svg{transition:none}',
      '#mmPu .mmPuBahn.mmPuAn .mmPuHalt,',
      '#mmPu .mmPuBahn.mmPuAn .mmPuHalt .mmPuTitelKlein,',
      '#mmPu .mmPuBahn.mmPuAn .mmPuHalt .mmPuText,',
      '#mmPu .mmPuBahn.mmPuAn .mmPuHalt .mmPuListe{',
        'opacity:1!important;transform:none!important;transition:none!important}}'
  ].join('');

  function schuetzen(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function bauen() {
    if (document.getElementById('mmPu')) return true;
    var anker = document.getElementById('mmWi');       /* direkt unter "Mehr zum Produkt" */
    if (!anker || !anker.parentNode) return false;

    var st = document.createElement('style');
    st.id = 'mmPu-stil'; st.textContent = css;
    (document.head || document.documentElement).appendChild(st);

    var sek = document.createElement('section');
    sek.id = 'mmPu';
    sek.setAttribute('aria-label', 'Kennst du das');
    sek.innerHTML =
      '<div class="mmPuInnen">' +
        '<div class="mmPuKopf">' +
          '<p class="mmPuAuge">Kennst du das</p>' +
          '<h2>Vier Sätze, die wir jeden Tag hören</h2>' +
          '<p class="mmPuUnter">Und was wirklich dahintersteckt — ohne Schönreden.</p>' +
        '</div>' +
        '<div class="mmPuPin"><div class="mmPuKleb">' +
        '<div class="mmPuBahn">' +
          '<span class="mmPuLinie"><span class="mmPuStrahl"></span></span>' +
          STATIONEN.map(function (s, i) {
            return '<div class="mmPuStation" style="--mmPuTon:' + TOENE[i] + ';--mmPuFlaeche:' + FLAECHEN[i] + '">' +
              '<div class="mmPuStand"><div class="mmPuHalt">' +
              '<div class="mmPuLinks">' +
                '<span class="mmPuPunkt">' +
                  '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                    (ZEICHEN[s.zeichen] || '') +
                  '</svg>' +
                '</span>' +
                '<h3 class="mmPuTitel">' + schuetzen(s.titel) + '</h3>' +
              '</div>' +
              '<div class="mmPuRechts">' +
                '<span class="mmPuTitelKlein">' + schuetzen(s.titel) + '</span>' +
                '<p class="mmPuText">' + schuetzen(s.text) + '</p>' +
                '<ul class="mmPuListe">' +
                  s.punkte.map(function (p) { return '<li>' + schuetzen(p) + '</li>'; }).join('') +
                '</ul>' +
              '</div>' +
            '</div></div></div>';
          }).join('') +
        '</div>' +
        '</div></div>' +
      '</div>';

    anker.parentNode.insertBefore(sek, anker.nextSibling);

    var bahn = sek.querySelector('.mmPuBahn');
    var stationen = [].slice.call(sek.querySelectorAll('.mmPuStation'));
    var media = window.matchMedia('(prefers-reduced-motion: reduce)');
    var trigger = [], aus = false, geladen = false, ladend = false, imBlick = false, nahe, resizeTimer;
    var breite = 0, ro;

    function scrollFlaeche() {
      /* Savor scrollt live in .page-wrapper, nicht im window.
         Den echten naechsten Scroll-Container nehmen; lokaler Standard
         und Themes ohne Wrapper behalten window als Fallback. */
      var el = sek.parentElement;
      while (el && el !== document.body && el !== document.documentElement) {
        var overflow = window.getComputedStyle(el).overflowY;
        if (/(auto|scroll)/.test(overflow) && el.scrollHeight > el.clientHeight + 1) return el;
        el = el.parentElement;
      }
      return window;
    }

    function kopfHoehe() {
      var h = document.querySelector('header-component, #header-group, header');
      var r = h && h.getBoundingClientRect();
      var pos = h && window.getComputedStyle(h).position;
      return r && (pos === 'fixed' || pos === 'sticky')
        ? Math.max(20, Math.min(160, r.bottom + 12)) : 88;
    }
    function sichtbar(h, wert, aktiv) {
      h.classList.toggle('gesehen', wert);
      h.classList.toggle('wach', wert && aktiv);
    }
    function freigeben() {
      trigger.forEach(function (t) { t.kill(true); });
      trigger = [];
      bahn.classList.remove('mmPuAn', 'mmPuScharf');
      stationen.forEach(function (s) {
        sichtbar(s.querySelector('.mmPuHalt'), true, false);
      });
    }
    function einrichten() {
      if (aus || !geladen) return;
      freigeben();
      if (media.matches) return;
      var ST = window.ScrollTrigger;
      var oben = kopfHoehe();
      var scroller = scrollFlaeche();
      var vh = scroller === window
        ? (window.innerHeight || document.documentElement.clientHeight) : scroller.clientHeight;
      bahn.classList.add('mmPuAn');
      stationen.forEach(function (s, i) {
        var stand = s.querySelector('.mmPuStand');
        var halt = s.querySelector('.mmPuHalt');
        var hoehe = stand.offsetHeight;
        var passt = hoehe > 0 && hoehe + oben + 16 <= vh;
        /* Einzelne Station statt der gesamten Vierer-Liste:
           auf dem Handy bleibt jetzt wirklich etwas stehen. Bei Zoom oder
           sehr kurzen Fenstern nie unerreichbaren Inhalt festklemmen. */
        var t = ST.create({
          id: 'mmPu-' + i,
          trigger: s,
          scroller: scroller,
          pin: passt ? stand : false,
          pinSpacing: true,
          start: passt ? 'top ' + oben + 'px' : 'top 82%',
          end: passt ? '+=' + Math.round(vh * .65) : 'bottom 30%',
          invalidateOnRefresh: true,
          onUpdate: function (self) {
            if (!document.hidden) sichtbar(halt, self.progress >= .05, self.isActive);
          },
          onRefresh: function (self) {
            sichtbar(halt, self.progress >= .05, self.isActive);
          },
          onToggle: function (self) {
            if (!document.hidden) sichtbar(halt, self.progress >= .05, self.isActive);
          }
        });
        trigger.push(t);
      });
      /* Starthaltung zuerst setzen; danach dieselben .55/.5-s-Einblendungen
         wie zuvor. Der gepinnte Stand selbst wird niemals animiert. */
      void bahn.offsetHeight;
      bahn.classList.add('mmPuScharf');
      ST.refresh();
    }
    function neuMessen() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(einrichten, 180);
    }
    function ruhe() {
      sek.classList.toggle('mmPuPause', document.hidden || !imBlick);
      if (!document.hidden) {
        trigger.forEach(function (t, i) {
          sichtbar(stationen[i].querySelector('.mmPuHalt'), t.progress >= .05, t.isActive);
        });
      }
    }
    function abbauen(e) {
      if (e && e.persisted) return;
      aus = true;
      window.clearTimeout(resizeTimer);
      freigeben();
      if (nahe) nahe.disconnect();
      if (ro) ro.disconnect();
      window.removeEventListener('resize', neuMessen);
      window.removeEventListener('pagehide', abbauen);
      document.removeEventListener('visibilitychange', ruhe);
      if (media.removeEventListener) media.removeEventListener('change', bewegung);
    }

    function motionLaden() {
      if (geladen || ladend || aus || media.matches) return;
      ladend = true;
      /* Nur die beiden vorhandenen 3.15-Dateien aus den Theme-Assets.
         Kein Drittanbieter-CDN, kein zweiter globaler Scroll-Controller. */
      function skript(name, vorhanden) {
        if (vorhanden()) return Promise.resolve();
        if (!skriptBasis) return Promise.reject(new Error('mmPu: Asset-Basis fehlt'));
        return new Promise(function (resolve, reject) {
          var el = document.createElement('script');
          el.src = new URL(name, skriptBasis).href;
          el.onload = function () { vorhanden() ? resolve() : reject(new Error(name)); };
          el.onerror = reject;
          document.head.appendChild(el);
        });
      }
      if (!window.mmPuMotionLaden) {
        window.mmPuMotionLaden = skript('mm-gsap-3-15.min.js', function () { return !!window.gsap; })
          .then(function () {
            return skript('mm-scrolltrigger-3-15.min.js', function () { return !!window.ScrollTrigger; });
          });
      }
      window.mmPuMotionLaden.then(function () {
        if (aus) return;
        window.gsap.registerPlugin(window.ScrollTrigger);
        geladen = true;
        einrichten();
        if ('ResizeObserver' in window) {
          ro = new ResizeObserver(function (e) {
            /* Nicht die gepinnten Elemente beobachten: beim Fixieren rundet
               der Browser deren Hoehe anders und loeste sonst Neubau-Schleifen aus. */
            var jetzt = e[0].contentRect.width;
            if (breite && Math.abs(jetzt - breite) > 1) neuMessen();
            breite = jetzt;
          });
          ro.observe(sek.querySelector('.mmPuInnen'));
        }
      }).catch(function () { freigeben(); });
    }
    function bewegung() {
      if (media.matches) freigeben();
      else if (geladen) einrichten();
      else motionLaden();
    }
    window.addEventListener('resize', neuMessen, { passive: true });
    window.addEventListener('pagehide', abbauen);
    document.addEventListener('visibilitychange', ruhe);
    if (media.addEventListener) media.addEventListener('change', bewegung);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(neuMessen);
    if ('IntersectionObserver' in window) {
      nahe = new IntersectionObserver(function (e) {
        imBlick = e[0].isIntersecting;
        sek.classList.toggle('mmPuPause', !imBlick || document.hidden);
        if (imBlick) motionLaden();
      }, { rootMargin: '0px' });
      nahe.observe(sek);
    } else { imBlick = true; motionLaden(); }
    return true;
  }

  var gebaut = false;
  function versuchen() {
    if (gebaut) return;
    if (bauen()) { gebaut = true; return; }
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen()) { gebaut = true; window.clearInterval(t); return; }
      if (n > 40) window.clearInterval(t);
    }, 700);
  }
  if ('MutationObserver' in window) {
    var wache = new MutationObserver(function () {
      if (gebaut) { wache.disconnect(); return; }
      if (document.getElementById('mmWi') && bauen()) { gebaut = true; wache.disconnect(); }
    });
    wache.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else { versuchen(); }
  window.addEventListener('load', versuchen);
})();
